<template>
  <div>
    <section-header heading="2" :ja="title"/>
    <div class="message">
      <div class="message__info" v-html="message"></div>
      <p class="message__info" v-if="supplement !== ''">{{ supplement }}</p>
    </div>
    <sub-btn v-if="!isMaintenance" @click="onBack">{{ buttonTitle }}</sub-btn>
  </div>
</template>

<script>
import Protobuf from '../mixins/protobuf'
import { errors } from "../assets/js/kumaerror";
import SectionHeader from '../components/SectionHeader'
import SubBtn from '@/components/SubBtn.vue'
const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web;
export default {
  name: "Error",
  components: {
    SectionHeader,
    SubBtn
  },
  mixins: [Protobuf],
  props: ['payload'],
  data() {
    return {
      statusCode: 100,
      title: '',
      message: '',
      supplement: '',
    }
  },
  computed: {
    buttonTitle() {
      return '戻る'
    },
    isMaintenance() {
      return this.statusCode === 300
    }
  },
  methods: {
    onBack() {
      switch (this.statusCode) {
        case 100:
        case 402:
        case 420:
        case 430:
        case 451:
        case 460:
        case 461:
        case 470:
          this.$router.push('/')
          break
        case 440:
        case 441:
        case 442:
          this.$router.push({ name: 'member', params: { fromError: true }})
          break
        case 471:
          this.$router.push('/member')
          break
        case 412:
        case 414:
          this.$router.push('/login')
          break
        case 403:
          this.$router.push('/login')
          break
        default:
          this.$router.go({ path: this.$router.currentRoute.path, force: true })
          break
      }
    },
    async maintenanceCheck(){
      const cmdNo = pb.KumaMasterSettingReq.CommandNo.COMMAND_NO;
      const message = pb.KumaMasterSettingReq.create({
        id:this.id,
      });
      const encoded = pb.KumaMasterSettingReq.encode(message).finish()

      this.post(cmdNo, encoded)
        .then(decoded => {
          this.supplement = this.$route.params.title
          if (decoded.status === pb.KumaMasterSettingResp.Status.SUCCESS && decoded.maintenanceTitle !== null && decoded.maintenanceInfo !== null) {
            this.title = decoded.maintenanceTitle
            this.message = decoded.maintenanceInfo
          } else if(decoded.status === pb.KumaMasterSettingResp.Status.SUCCESS && (decoded.maintenanceTitle === '' || decoded.maintenanceInfo === '')){
            this.title = 'ただいまメンテナンス中です'
            this.message = 'メンテナンス終了まで\n' + 'しばらくお待ちください'
          } else if(decoded.status === pb.KumaMasterSettingResp.Status.SUCCESS && (decoded.maintenanceTitle === null || decoded.maintenanceInfo === null)){
            this.title = 'ただいまメンテナンス中です'
            this.message = 'メンテナンス終了まで\n' + 'しばらくお待ちください'
          }
        })
        .catch(() => {
          this.title = 'ただいまメンテナンス中です'
          this.message = 'メンテナンス終了まで\n' + 'しばらくお待ちください'
          this.supplement = this.$route.params.title
        })
    },
  },
  mounted() {
    if (this['payload'] && this.payload['statusCode']) {
      this.statusCode = this.payload.statusCode
    } else if (this.$route.params['statusCode']) {
      this.statusCode = parseInt(this.$route.params.statusCode)
    } else {
      this.statusCode = 100
    }
    if (this.isMaintenance) {
      this.maintenanceCheck();
    } else {
      if (this['payload'] && this.payload['title']) {
        this.title = this.payload.title
      } else if (this.$route.params['title']) {
        this.title = this.$route.params.title
      } else {
        this.title = '不明'
      }
      if(this['payload'] && this.payload['data']) {
        this.message = this.payload['data'].title
        this.supplement = this.payload['data'].info
      } else if (errors[this.statusCode]) {
        this.message = errors[this.statusCode].message
        this.supplement = errors[this.statusCode].supplement
      } else {
        this.message = errors[100].message
        this.supplement = errors[100].supplement
      }
    }
    if(this.statusCode === 426) this.$router.push('/AlreadyDownloaded')
  }
}
</script>

<style lang="scss" scoped>
.message {
  font-size: 12px;
  white-space: pre-wrap;
  &__info{
    margin: 30px 30px 0;
  }
}
</style>
